import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** Tom fixo de cada status (glossário em docs/DESIGN-SYSTEM.md). Nunca use `green` (ação) para status. */
export type StatusTone = "ok" | "wait" | "info" | "crit" | "neutral";

/** Fundo e texto de cada tom: a etiqueta e o círculo do ícone do `AtalhoCard`. */
export const TOM_STATUS: Record<StatusTone, string> = {
    ok: "bg-ok-bg text-ok",
    wait: "bg-wait-bg text-wait",
    info: "bg-info-bg text-info",
    crit: "bg-crit-bg text-crit",
    neutral: "bg-neutral-bg text-neutral",
};

/** Só o texto no tom (um valor que pede atenção, o ícone de um aviso). */
export const TEXTO_DO_TOM: Record<StatusTone, string> = { ok: "text-ok", wait: "text-wait", info: "text-info", crit: "text-crit", neutral: "text-neutral" };

/** O ponto no tom (grupo de lista, marco de linha do tempo). */
export const PONTO_DO_TOM: Record<StatusTone, string> = { ok: "bg-ok", wait: "bg-wait", info: "bg-info", crit: "bg-crit", neutral: "bg-neutral" };

interface StatusPillProps {
    tone: StatusTone;
    children: ReactNode;
    className?: string;
}

export function StatusPill({ tone, children, className }: StatusPillProps) {
    return (
        <span
            className={cn(
                "inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-caption",
                TOM_STATUS[tone],
                className,
            )}
        >
            <i className="size-1.5 rounded-full bg-current" aria-hidden />
            {children}
        </span>
    );
}
